(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bjp-card-quick-add-panel"] && !Shopify.designMode) return;
  try {
    (() => {
  function init() {
    const root = document.querySelector('[data-bjp-card-cart]');
    if (!root || customElements.get('bjp-quick-add')) return;
    const dialog = root.querySelector('dialog');
    const form = root.querySelector('form');
    const nativeAdd = form.querySelector('button');
    const submit = root.querySelector('[data-card-submit]');
    const options = root.querySelector('[data-card-options]');
    const error = root.querySelector('[data-card-error]');
    let active, opener, choice, busy = false, added = false, cartEscape = false;

    customElements.define('bjp-quick-add', class extends HTMLElement {
      connectedCallback() {
        this.product = JSON.parse(this.querySelector('[data-card-product]').textContent);
        this.sizeIndex = this.product.options.findIndex(name => name.toLowerCase() === 'size');
        this.card = this.closest('.product-card');
        this.refresh();
        const swatches = this.card.querySelector('.product-swatches');
        if (swatches) {
          this.observer = new MutationObserver(() => this.refresh());
          this.observer.observe(swatches, {subtree: true, attributes: true, attributeFilter: ['class']});
        }
      }
      disconnectedCallback() { this.observer?.disconnect(); }
      selection() {
        const variant = this.product.variants.find(v => v.id === this.product.selected) || this.product.variants[0];
        const selected = [...variant.options];
        this.card.querySelectorAll('.product-swatches .swatch.selected').forEach(swatch => {
          const index = this.product.options.indexOf(swatch.dataset.name);
          if (index >= 0) selected[index] = swatch.dataset.value;
        });
        return selected;
      }
      refresh() {
        const swatch = this.card.querySelector('.product-swatches .swatch.selected');
        this.card.classList.toggle('bjp-card-alternate-color', this.product.secondImageMatches === false || Boolean(swatch?.dataset.src && new URL(swatch.dataset.src, location.href).pathname !== new URL(this.product.image, location.href).pathname));
        this.querySelectorAll('[data-card-size]').forEach(button => {
          const selected = this.selection();
          selected[this.sizeIndex] = button.dataset.cardSize;
          const variant = this.product.variants.find(v => v.options.every((value, index) => value === selected[index]));
          button.disabled = !variant?.available;
        });
        this.querySelectorAll('[data-card-open]').forEach(button => {
          button.disabled = !this.product.variants.some(v => v.available);
        });
      }
    });

    function selectedVariant() {
      return active.product.variants.find(v => v.options.every((value, index) => value === choice[index]));
    }
    function updatePanel() {
      const variant = selectedVariant();
      const shownVariant = variant || active.product.variants.find(v => v.options.every((value, index) => choice[index] == null || value === choice[index]));
      options.querySelectorAll('button').forEach(button => {
        const index = Number(button.dataset.option);
        button.setAttribute('aria-pressed', String(choice[index] === button.dataset.value));
        button.disabled = busy || !active.product.variants.some(v => v.available && v.options[index] === button.dataset.value && v.options.every((value, other) => other === index || other === active.sizeIndex || choice[other] == null || choice[other] === value));
      });
      submit.disabled = busy || !variant?.available;
      submit.textContent = busy ? root.dataset.adding : active.product.variants.some(v => v.available) ? root.dataset.add : root.dataset.soldOut;
      root.querySelector('[data-card-price]').textContent = shownVariant?.price || active.product.price;
      const image = root.querySelector('[data-card-image]');
      const imageUrl = shownVariant?.image || active.product.image;
      image.hidden = !imageUrl;
      if (imageUrl) image.src = imageUrl;
      root.querySelector('[data-card-details]').href = active.product.url + (variant ? '?variant=' + variant.id : '');
      dialog.setAttribute('aria-busy', String(busy));
    }
    function showPanel() {
      root.querySelector('#BjpCardSizeTitle').textContent = active.sizeIndex >= 0 ? root.dataset.sizeTitle : root.dataset.optionsTitle;
      root.querySelector('[data-card-title]').textContent = active.product.title;
      const image = root.querySelector('[data-card-image]');
      image.hidden = !active.product.image;
      if (active.product.image) image.src = active.product.image;
      options.replaceChildren();
      active.product.options.forEach((name, index) => {
        const values = [...new Set(active.product.variants.map(v => v.options[index]))];
        if (values.length === 1 && (name === 'Title' || active.product.variants.length === 1)) return;
        const fieldset = document.createElement('fieldset');
        const legend = document.createElement('legend');
        legend.textContent = name;
        const group = document.createElement('div');
        group.className = 'bjp-card-option-values';
        values.forEach(value => {
          const button = document.createElement('button');
          button.type = 'button';
          button.dataset.option = index;
          button.dataset.value = value;
          button.textContent = value;
          group.append(button);
        });
        fieldset.append(legend, group);
        options.append(fieldset);
      });
      updatePanel();
      if (!dialog.open) dialog.showModal();
      root.querySelector('[data-card-close]').focus();
    }
    function add() {
      const variant = selectedVariant();
      if (busy || !variant?.available) return;
      busy = true;
      error.hidden = true;
      active.setAttribute('aria-busy', 'true');
      form.querySelector('[name="id"]').value = variant.id;
      updatePanel();
      btyAddToCart(root);
      nativeAdd.click();
    }
    document.addEventListener('click', event => {
      const button = event.target.closest('[data-card-size], [data-card-open]');
      if (!button) return;
      const card = button.closest('bjp-quick-add');
      if (!card) return;
      event.preventDefault();
      event.stopPropagation();
      if (busy || button.disabled) return;
      active = card;
      opener = button;
      added = false;
      error.hidden = true;
      choice = active.selection();
      if (button.hasAttribute('data-card-size')) {
        choice[active.sizeIndex] = button.dataset.cardSize;
        add();
      } else if (active.product.variants.length === 1) {
        add();
      } else {
        if (active.sizeIndex >= 0) choice[active.sizeIndex] = null;
        else choice[active.product.options.findIndex((name, index) => new Set(active.product.variants.map(v => v.options[index])).size > 1)] = null;
        showPanel();
      }
    });
    options.addEventListener('click', event => {
      const button = event.target.closest('button');
      if (!button || button.disabled || busy) return;
      choice[Number(button.dataset.option)] = button.dataset.value;
      if (!selectedVariant()?.available && Number(button.dataset.option) !== active.sizeIndex && active.sizeIndex >= 0) choice[active.sizeIndex] = null;
      error.hidden = true;
      updatePanel();
    });
    submit.addEventListener('click', add);
    root.querySelector('[data-card-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    });
    dialog.addEventListener('close', () => { if (!added) opener?.focus({preventScroll: true}); });
    dialog.addEventListener('keydown', event => {
      if (event.key === 'Escape' && opener?.closest('.side-cart')) cartEscape = true;
      if (event.key !== 'Tab') return;
      const stops = [...dialog.querySelectorAll('button:not(:disabled),a[href]')].filter(el => el.getClientRects().length);
      const first = stops[0], last = stops[stops.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
    document.addEventListener('keyup', event => {
      if (event.key === 'Escape' && cartEscape) { event.stopImmediatePropagation(); cartEscape = false; }
    }, true);
    form.addEventListener('bjp:cart-added', () => { added = true; if (dialog.open) dialog.close(); });
    form.addEventListener('bjp:cart-error', event => {
      error.textContent = event.detail?.message || root.dataset.error;
      error.hidden = false;
      showPanel();
    });
    form.addEventListener('bjp:cart-idle', () => {
      busy = false;
      active.removeAttribute('aria-busy');
      updatePanel();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bjp-cart-recommendations"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('bjp-cart-recommendations')) return;
  customElements.define('bjp-cart-recommendations', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-rec-track]');
      this.previous = this.querySelector('[data-rec-prev]');
      this.next = this.querySelector('[data-rec-next]');
      this.items = this.closest('.side-cart').querySelector('.cart-items');
      this.refresh = this.refresh.bind(this);
      this.observer = new MutationObserver(this.refresh);
      this.observer.observe(document.documentElement, {attributes:true, attributeFilter:['class']});
      if (this.items) this.observer.observe(this.items, {childList:true, subtree:true});
      this.previous.addEventListener('click', () => this.move(-1));
      this.next.addEventListener('click', () => this.move(1));
      this.track.addEventListener('scroll', () => this.updateArrows(), {passive:true});
      this.resize = new ResizeObserver(() => this.updateArrows());
      this.resize.observe(this.track);
      this.refresh();
    }
    disconnectedCallback() { this.observer.disconnect(); this.resize.disconnect(); this.controller?.abort(); }
    move(direction) {
      const card = this.track.firstElementChild;
      if (card) this.track.scrollBy({left:direction * (card.getBoundingClientRect().width + 10),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    }
    updateArrows() {
      this.previous.disabled = this.track.scrollLeft <= 2;
      this.next.disabled = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2;
    }
    async recommendations(seed, intent, signal) {
      const url = new URL(this.dataset.url, location.origin);
      url.search = new URLSearchParams({product_id:seed,section_id:'bjp-cart-recommendations',limit:'10',intent});
      try {
        const response = await fetch(url, {signal});
        if (!response.ok) return [];
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        return [...html.querySelectorAll('[data-cart-recommendation-results] [data-rec-id]')];
      } catch { return []; }
    }
    async refresh() {
      if (!document.documentElement.classList.contains('side-cart-open')) return;
      const items = [...(this.items?.querySelectorAll('[data-product-id]') || [])];
      const ids = items.map(item => item.dataset.productId);
      const signature = ids.join(',');
      if (signature === this.signature) return;
      this.signature = signature;
      this.controller?.abort();
      const controller = new AbortController();
      this.controller = controller;
      const {signal} = controller;
      this.hidden = true;
      if (!ids.length) return;
      const timer = setTimeout(() => controller.abort(), 4000);
      const excluded = new Set(ids);
      const cartTypes = new Set(items.map(item => item.dataset.productType));
      const complementary = await this.recommendations(ids[0], 'complementary', signal);
      const related = complementary.filter(card => !excluded.has(card.dataset.recId)).length < 3 ? await this.recommendations(ids[0], 'related', signal) : [];
      clearTimeout(timer);
      if (!this.isConnected || this.controller !== controller) return;
      const fallback = [...this.querySelector('[data-rec-fallback]').content.querySelectorAll('[data-rec-id]')];
      const pool = [...related, ...fallback];
      const preferred = pool.filter(card => !cartTypes.has(card.dataset.recType));
      const chosen = [], types = new Set();
      for (const card of [...complementary, ...preferred, ...pool]) {
        if (excluded.has(card.dataset.recId)) continue;
        if (!complementary.includes(card) && types.has(card.dataset.recType) && chosen.length < 2) continue;
        chosen.push(card.cloneNode(true));
        excluded.add(card.dataset.recId);
        types.add(card.dataset.recType);
        if (chosen.length === 3) break;
      }
      this.track.replaceChildren(...chosen);
      this.track.scrollLeft = 0;
      this.hidden = chosen.length === 0;
      this.updateArrows();
    }
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bjp-mobile-menu"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('bjp-mobile-menu')) return;
  class BjpMobileMenu extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.opener = document.querySelector(`[aria-controls="${this.dialog.id}"]`);
      this.desktop = matchMedia('(min-width:1024px)');
      this.close = () => {
        document.documentElement.classList.remove('site-panel-open');
        if (this.dialog.open) this.dialog.close();
        this.opener?.setAttribute('aria-expanded', 'false');
      };
      this.sync = () => {
        const open = document.documentElement.classList.contains('site-panel-open') && !this.desktop.matches;
        this.opener?.setAttribute('aria-expanded', String(open));
        if (open && !this.dialog.open) {
          document.querySelectorAll('.bjp-search[open]').forEach(search => { search.open = false; });
          this.dialog.showModal();
          this.querySelector('.site-panel-close').focus({preventScroll:true});
        } else if (!open && this.dialog.open) this.dialog.close();
      };
      this.dialog.addEventListener('cancel', event => { event.preventDefault(); this.close(); });
      this.dialog.addEventListener('keydown', event => {
        if (event.key !== 'Tab') return;
        const focusable = [...this.dialog.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled])')].filter(element => element.getClientRects().length);
        const first = focusable[0], last = focusable.at(-1);
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      });
      this.dialog.addEventListener('close', () => {
        this.close();
        if (!document.querySelector('dialog[open]')) this.opener?.focus({preventScroll:true});
      });
      this.addEventListener('click', event => {
        if (event.target.closest('.site-panel-close, a, [data-bjp-wishlist-open]')) {
          this.close();
          if (event.target.closest('[data-bjp-wishlist-open]')) document.querySelector('.header-icons [data-bjp-wishlist-open]')?.focus({preventScroll:true});
        }
      });
      this.querySelector('form').addEventListener('submit', () => this.close());
      this.onDesktop = () => { if (this.desktop.matches) this.close(); };
      this.desktop.addEventListener('change', this.onDesktop);
      this.observer = new MutationObserver(this.sync);
      this.observer.observe(document.documentElement, {attributes:true, attributeFilter:['class']});
      this.sync();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.desktop?.removeEventListener('change', this.onDesktop);
    }
  }
  customElements.define('bjp-mobile-menu', BjpMobileMenu);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bjp-navigation"] && !Shopify.designMode) return;
  try {
    (() => {
  const hover = window.matchMedia('(min-width: 1024px) and (hover: hover) and (pointer: fine)');
  const selector = '.bjp-navigation--desktop details';

  const setup = (root) => {
    root.querySelectorAll(selector).forEach((menu) => {
      if (menu.dataset.hoverReady) return;
      menu.dataset.hoverReady = 'true';
      let closeTimer;

      menu.addEventListener('pointerenter', (event) => {
        if (!hover.matches || event.pointerType !== 'mouse') return;
        window.clearTimeout(closeTimer);
        menu.closest('.bjp-navigation').querySelectorAll('details[open]').forEach((other) => {
          if (other !== menu && !other.contains(menu)) other.open = false;
        });
        menu.open = true;
      });

      menu.addEventListener('pointerleave', (event) => {
        if (!hover.matches || event.pointerType !== 'mouse') return;
        window.clearTimeout(closeTimer);
        closeTimer = window.setTimeout(() => {
          if (!menu.contains(document.activeElement)) menu.open = false;
        }, 250);
      });

      menu.addEventListener('focusout', (event) => {
        if (!menu.contains(event.relatedTarget) && !menu.matches(':hover')) menu.open = false;
      });

      menu.addEventListener('toggle', () => {
        if (!menu.open) window.clearTimeout(closeTimer);
      });
    });
  };

  setup(document);
  document.addEventListener('shopify:section:load', (event) => setup(event.target));
  hover.addEventListener('change', () => {
    document.querySelectorAll(selector).forEach((menu) => { menu.open = false; });
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bjp-size-guide"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',event=>{
  const opener=event.target.closest('[data-bjp-size-guide]');
  if(opener){const dialog=document.getElementById(opener.dataset.bjpSizeGuide);if(dialog&&typeof dialog.showModal==='function'){event.preventDefault();dialog.showModal();}return;}
  const closer=event.target.closest('[data-bjp-close-dialog]');
  if(closer){closer.closest('dialog').close();return;}
  const unit=event.target.closest('[data-bjp-unit]');
  if(unit){const dialog=unit.closest('dialog');dialog.dataset.unit=unit.dataset.bjpUnit;dialog.querySelectorAll('[data-bjp-unit]').forEach(button=>button.setAttribute('aria-pressed',String(button===unit)));}
  if(event.target.matches('.bjp-size-dialog')){const rect=event.target.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)event.target.close();}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bjp-us-design"] && !Shopify.designMode) return;
  try {
    document.addEventListener('keydown',event=>{if(event.key==='Escape'){document.querySelectorAll('.bjp-search[open],.bjp-shop-menu[open]').forEach(details=>{details.open=false;details.querySelector('summary').focus();});}});
document.addEventListener('click',event=>{document.querySelectorAll('.bjp-search[open],.bjp-shop-menu[open]').forEach(details=>{if(!details.contains(event.target))details.open=false;});});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bjp-wishlist"] && !Shopify.designMode) return;
  try {
    (() => {
  const dialog = document.querySelector('[data-bjp-wishlist]');
  if (!dialog) return;
  const key = 'bjp-wishlist-v1';
  const list = dialog.querySelector('[data-bjp-wishlist-list]');
  const empty = dialog.querySelector('[data-bjp-wishlist-empty]');
  const status = dialog.querySelector('[data-bjp-wishlist-status]');
  const announcement = document.querySelector('[data-bjp-wishlist-announcement]');
  let handles = [];
  let storageAvailable = true;
  let revision = 0;
  const read = () => {
    try {
      const value = JSON.parse(localStorage.getItem(key) || '[]');
      return Array.isArray(value) ? [...new Set(value.filter(handle => typeof handle === 'string' && /^[a-z0-9-]+$/.test(handle)))] : [];
    } catch { storageAvailable = false; return []; }
  };
  handles = read();
  const update = () => {
    document.querySelectorAll('[data-bjp-favorite]').forEach(button => {
      const saved = handles.includes(button.dataset.bjpFavorite);
      button.hidden = false;
      button.setAttribute('aria-pressed', String(saved));
      button.setAttribute('aria-label', (saved ? button.dataset.removeLabel : button.dataset.saveLabel).replace('__PRODUCT__', button.dataset.productTitle));
    });
    document.querySelectorAll('[data-bjp-wishlist-open]').forEach(button => {
      button.hidden = false;
      button.setAttribute('aria-label', dialog.dataset.countLabel.replace('__COUNT__', handles.length));
    });
    document.querySelectorAll('[data-bjp-wishlist-count]').forEach(badge => {
      badge.textContent = handles.length;
      badge.hidden = handles.length === 0;
    });
    dialog.querySelector('[data-bjp-wishlist-total]').textContent = handles.length ? `(${handles.length})` : '';
    dialog.querySelector('[data-bjp-wishlist-warning]').hidden = storageAvailable;
  };
  const render = async (restoreFocus = false) => {
    const current = ++revision;
    const saved = [...handles];
    list.replaceChildren();
    empty.hidden = saved.length > 0;
    status.textContent = saved.length ? dialog.dataset.loading : '';
    const products = await Promise.all(saved.map(async handle => {
      try {
        const response = await fetch(`${dialog.dataset.root}products/${encodeURIComponent(handle)}.js`);
        if (!response.ok) return { handle, error: response.status === 404 ? dialog.dataset.unavailable : dialog.dataset.loadError };
        return { handle, product: await response.json() };
      } catch { return { handle, error: dialog.dataset.loadError }; }
    }));
    if (current !== revision) return;
    products.forEach(({ handle, product, error }) => {
      const item = dialog.querySelector('[data-bjp-wishlist-item]').content.cloneNode(true);
      const title = product?.title || handle.replaceAll('-', ' ');
      const url = `${dialog.dataset.root}products/${encodeURIComponent(handle)}`;
      item.querySelectorAll('[data-wishlist-link]').forEach(link => { link.href = url; });
      const titleLink = item.querySelector('[data-wishlist-title]');
      titleLink.textContent = title;
      titleLink.href = url;
      if (product?.featured_image) {
        const image = item.querySelector('[data-wishlist-image]');
        const imageUrl = new URL(product.featured_image, location.origin);
        imageUrl.searchParams.set('width', '240');
        image.src = imageUrl.href;
        image.hidden = false;
      }
      if (product) {
        const price = new Intl.NumberFormat(dialog.dataset.locale, {style:'currency', currency:dialog.dataset.currency}).format(product.price / 100);
        item.querySelector('[data-wishlist-price]').textContent = product.price_varies ? dialog.dataset.fromPrice.replace('__PRICE__', price) : price;
      }
      item.querySelector('[data-wishlist-item-status]').textContent = error || (product.available ? '' : dialog.dataset.soldOut);
      const remove = item.querySelector('[data-wishlist-remove]');
      remove.dataset.wishlistRemove = handle;
      remove.setAttribute('aria-label', dialog.dataset.removeLabel.replace('__PRODUCT__', title));
      list.append(item);
    });
    status.textContent = '';
    if (restoreFocus && dialog.open) (list.querySelector('[data-wishlist-remove]') || dialog.querySelector('[data-bjp-wishlist-close]')).focus();
  };
  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-bjp-wishlist-open]');
    if (opener) { dialog.showModal(); render(); return; }
    if (event.target.closest('[data-bjp-wishlist-close]')) { dialog.close(); return; }
    if (event.target === dialog) {
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      return;
    }
    const button = event.target.closest('[data-bjp-favorite], [data-wishlist-remove]');
    if (!button) return;
    const handle = button.dataset.bjpFavorite || button.dataset.wishlistRemove;
    const saved = handles.includes(handle);
    handles = saved ? handles.filter(value => value !== handle) : [...handles, handle];
    try { localStorage.setItem(key, JSON.stringify(handles)); } catch { storageAvailable = false; }
    update();
    announcement.textContent = storageAvailable ? (saved ? dialog.dataset.removed : dialog.dataset.saved) : dialog.querySelector('[data-bjp-wishlist-warning]').textContent;
    if (dialog.open) render(true);
  });
  document.addEventListener('product-card-updated', update);
  window.addEventListener('storage', event => {
    if (event.key !== key && event.key !== null) return;
    handles = read();
    update();
    if (dialog.open) render();
  });
  update();
})();
  } catch(e) { console.error(e); }
})();

})();
